export const signUpRoute = '/user/signup';
export const logInRoute = '/user/login';
export const refreshTokenRoute = '/user/refresh';
export const logOutRoute = '/user/logout';
export const updateUserRoute = '/user/update';
